import { ClientResponseError } from '$lib/api/ClientResponseError';
import { toastPosition } from '$stores';
import { toast, type ToastPosition } from 'svoast';
import Toast from '$components/reusable/Toast.svelte';

export const toastCustom = (options: {
  position: ToastPosition;
  title?: string;
  description?: string;
  positive?: boolean;
  warning?: boolean;
  negative?: boolean;
  informational?: boolean;
  noIcon?: boolean;
  contentFit?: boolean;
}) => {
  const { position, ...toastProps } = options;
  toastPosition.set(position);
  toast.success('Successfully saved!', {
    component: [Toast, toastProps],
  });
};

// biome-ignore lint/suspicious/noExplicitAny: TODO: fix this missing type
export const toastError = async (error: any) => {
  let errorString: string;
  if (typeof error === 'string') {
    errorString = error;
  } else if (error instanceof ClientResponseError) {
    if (error.status === 401) return;
    errorString = error.message;
  } else if (error.isSuperTokensGeneralError === true) {
    errorString = error.message;
  } else if (error?.status >= 400 && error?.status < 500) {
    errorString = await error.json();
  } else errorString = 'Something went wrong. Please try again';

  toastCustom({
    position: 'bottom-center',
    negative: true,
    description: errorString,
  });
};
